module.exports = __webpack_public_path__ + "img/Behandlungsplatz.1bb468a9.svg";